import { ToolScale } from '../draw-canvas.constants';
import * as Styled from './tool-size.style';
import { rem } from 'approot/shared/style';

type Props = {
  size: number;
  scale: ToolScale;
  hidePreview?: boolean;
  setSize: (value: number) => void;
};

const ToolSize = ({ size, scale, hidePreview, setSize }: Props) => (
  <Styled.ToolSizeContainerRange>
    <Styled.ToolTrack>
      <Styled.ToolBgTrack>
        <Styled.ToolFillTrack
          $width={((size - scale.min) / (scale.max - scale.min)) * 100}
        />
      </Styled.ToolBgTrack>
      <Styled.ToolRange
        min={scale.min}
        max={scale.max}
        step={scale.step}
        value={size}
        onChange={e => setSize(Number(e.target.value))}
      />
    </Styled.ToolTrack>
    <Styled.ToolSizeValue>{size}</Styled.ToolSizeValue>
    {!hidePreview && (
      <Styled.ToolSizePreviewContainer>
        <Styled.ToolSizePreview
          style={{
            borderRadius: rem(size),
            height: rem(size),
            width: rem(size),
          }}
          $size={size}
        />
      </Styled.ToolSizePreviewContainer>
    )}
  </Styled.ToolSizeContainerRange>
);

export default ToolSize;
